import noImageCompany from '../../../../../assets/images/emptyCompany.jpg';
import CardShopTheLook from '../../../../layouts/Card/cardContent/CardShopTheLook';
import CardSummary from '../../../../layouts/Card/cardContent/CardSummary';

export const listSettings = {
    grid: {
        components: CardSummary,
        columns: {
            xs: 1,
            sm: 2,
            laptop: 3,
        }
    },
}

export const listMappers = [
    {
        view: 'card',
        mapper: null
    },
    // {
    //     view : 'table',
    //     mapper : 'companiesListMapper'
    // }
]

export const perPageOptions = {
    'card': [6, 12, 24],
}

